import _extends from "@babel/runtime/helpers/extends";
import { Text } from '@wix/design-system';
import * as React from 'react';
import { EllipsisContext } from './EllipsisContext';
import s from './EllipsisText.scss';
export const EllipsisText = _ref => {
  let {
    text,
    maxWidth,
    componentProps = {},
    as: Component = Text,
    delimiterPosition = 'middle'
  } = _ref;
  const delimiter = '...';
  const rootSpanRef = React.useRef(null);
  const testNodeSpanRef = React.useRef(null);
  const [isInitialized, setIsInitialized] = React.useState(false);
  const {
    displayTruncatedText,
    setDisplayTruncatedText
  } = React.useContext(EllipsisContext);
  React.useEffect(() => {
    setIsInitialized(true);
    setDisplayTruncatedText(calculateTruncatedText(text, delimiter, rootSpanRef, testNodeSpanRef, maxWidth, delimiterPosition));
  }, []);
  React.useEffect(() => {
    setDisplayTruncatedText(calculateTruncatedText(text, delimiter, rootSpanRef, testNodeSpanRef, maxWidth, delimiterPosition));
  }, [maxWidth, text, delimiterPosition]);
  const rootClassName = [s.root, isInitialized ? s.initialized : '', !isInitialized ? s.fullWidth : ''].filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("span", {
    className: rootClassName,
    ref: rootSpanRef
  }, /*#__PURE__*/React.createElement(Component, _extends({}, componentProps, {
    dataHook: "ellipsis-text"
  }), displayTruncatedText), /*#__PURE__*/React.createElement("span", {
    className: s.testNodeWrapper
  }, /*#__PURE__*/React.createElement(Component, componentProps, /*#__PURE__*/React.createElement("span", {
    ref: testNodeSpanRef,
    className: s.testText
  }))));
};
const measureTextWidth = (testNodeSpanRef, content) => {
  if (testNodeSpanRef.current) {
    testNodeSpanRef.current.textContent = content;
    return testNodeSpanRef.current.getBoundingClientRect().width;
  }
  return 0;
};
const fitTextWithinWidth = function (testNodeSpanRef, textPart, maxWidth, reverse) {
  if (reverse === void 0) {
    reverse = false;
  }
  let displayText = textPart;
  while (measureTextWidth(testNodeSpanRef, displayText) > maxWidth) {
    displayText = reverse ? displayText.slice(1) : displayText.slice(0, -1);
  }
  return displayText;
};
const getMaxWidth = (rootSpanRef, maxWidth) => {
  if (maxWidth) {
    return maxWidth;
  }
  if (rootSpanRef.current) {
    return rootSpanRef.current.getBoundingClientRect().width;
  }
  return 0;
};
const calculateTruncatedText = function (text, delimiter, rootSpanRef, testNodeSpanRef, maxWidth, delimiterPosition) {
  if (delimiterPosition === void 0) {
    delimiterPosition = 'middle';
  }
  const fullTextWidth = measureTextWidth(testNodeSpanRef, text);
  const availableWidth = getMaxWidth(rootSpanRef, maxWidth);
  if (fullTextWidth <= availableWidth) {
    return text;
  }
  const delimiterWidth = measureTextWidth(testNodeSpanRef, delimiter);
  const availableTextWidth = availableWidth - delimiterWidth;
  if (delimiterPosition === 'start') {
    const truncatedPart = fitTextWithinWidth(testNodeSpanRef, text, availableTextWidth, true);
    return `${delimiter}${truncatedPart}`;
  }
  if (delimiterPosition === 'end') {
    const truncatedPart = fitTextWithinWidth(testNodeSpanRef, text, availableTextWidth);
    return `${truncatedPart}${delimiter}`;
  }
  const halfWidth = availableTextWidth / 2;
  const leftPart = fitTextWithinWidth(testNodeSpanRef, text.slice(0, text.length / 2), halfWidth);
  const rightPart = fitTextWithinWidth(testNodeSpanRef, text.slice(text.length / 2), halfWidth, true);
  return `${leftPart}${delimiter}${rightPart}`;
};
//# sourceMappingURL=EllipsisText.js.map